import classNames from 'classnames';
import styles from './Link.module.scss';

export interface LinkProps {
	children: React.ReactNode;
	style?: 'primary' | 'sm' | 'secondary';
	ariaLabel?: string;
	className?: string;
	url?: string;
	title?: string;
	asText?: boolean;
	download?: string;
	target?: string;
	onClick?: () => void;
}

export const Link: React.FC<LinkProps> = ({ children, style, ariaLabel, className, url, asText, download, title, target, onClick }) => (
	<>
		{asText ? (
			<p className={classNames(styles.Link, styles[`Link___${style}`], className)}>{children}</p>
		) : (
			<a
				title={title}
				href={url}
				aria-label={ariaLabel}
				className={classNames(styles.Link, styles[`Link___${style}`], className)}
				download={download}
				target={target}
				onClick={onClick}
			>
				{children}
			</a>
		)}
	</>
);
